import { Field, FieldAttributes, FieldProps } from 'formik';
import { forwardRef, useMemo } from 'react';
import Checkbox, { CheckboxProps } from './Checkbox';

interface FormikCheckboxProps extends CheckboxProps {
    fieldProps?: FieldAttributes<any>;
}

const FormikCheckbox = forwardRef<HTMLInputElement, FormikCheckboxProps>((props, ref) => {
    const { name, id, fieldProps, ...rest } = props;

    const idOrName = useMemo(() => {
        return id || name;
    }, [id, name]);

    return (
        <Field name={name} {...fieldProps}>
            {({ field }: FieldProps) => <Checkbox {...rest} {...field} ref={ref} id={idOrName} name={name} />}
        </Field>
    );
});

export default FormikCheckbox;
